/**
 * `FullSsnOrderType` is sent on POST `users/ssn` so the BE knows which flow
 * triggered the full SSN/TIN submission. `Sell` is the historical default
 * (sent implicitly by the standard Sell wizard); `SellFromHome` must be
 * passed explicitly from the Sell From Home (SFH) flow.
 */
export const FullSsnOrderType = {
  Sell: 1,
  SellFromHome: 2,
};
